import type { RouteRecordRaw } from 'vue-router';
import { ERROR_ROUTE_NAME } from './consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const notFoundRoutes: RouteRecordRaw = {
  path: '/:pathMatch(.*)*',
  component: () => import('@/layouts/blank.vue'),
  meta: { i18n },
  children: [
    {
      path: '',
      name: ERROR_ROUTE_NAME.NOT_FOUND,
      component: () => import('./Error404.vue'),
    },
  ],
};
